export default "__VITE_ASSET__D6q2pskY__"